// AuthGate — 登录守卫
// 未登录时显示品牌欢迎页 + 强制登录/注册界面，登录成功后才渲染主应用
// 满足需求："前端程序需要登陆后才能使用"

import type { ReactNode } from 'react';
import { useAuthStore } from '../../store/authStore';
import { AuthModal } from './AuthModal';

export function AuthGate({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => !!s.token);

  // 已登录 → 渲染主应用
  if (isAuthenticated) {
    return <>{children}</>;
  }

  // 未登录 → 全屏品牌页 + 强制登录弹窗（不可关闭）
  return (
    <>
      <div className="h-full flex flex-col items-center justify-center bg-gradient-to-b from-primary/5 via-bg to-bg p-4 overflow-y-auto">
        {/* 品牌区 */}
        <div className="text-center mb-6 mt-8">
          <div className="text-7xl mb-3 animate-fade-in">🚤</div>
          <h1 className="text-3xl font-bold text-ink">快船</h1>
          <p className="text-sm text-muted mt-2">极速跨设备文件传输 · 聊天 · 好友分享</p>
          <div className="flex gap-1.5 justify-center mt-3 text-xs text-muted flex-wrap">
            <span className="px-2 py-0.5 rounded-full bg-surface">扫码即连</span>
            <span className="px-2 py-0.5 rounded-full bg-surface">P2P 直连</span>
            <span className="px-2 py-0.5 rounded-full bg-surface">不限速</span>
            <span className="px-2 py-0.5 rounded-full bg-surface">文件不经服务器</span>
          </div>
        </div>

        {/* 功能亮点（SEO 友好的静态文本） */}
        <div className="max-w-sm w-full space-y-2 mb-6">
          {[
            ['🔗', '四种连接', '扫码 / 配对码 / 链接 / 同账号自动发现'],
            ['💬', '即时聊天', '文字 / 图片 / 表情，微信风格体验'],
            ['👥', '好友分享', '添加好友，随时互传文件'],
            ['⚡', '无限制传输', '文件大小无上限，P2P 端到端'],
          ].map(([icon, title, desc]) => (
            <div key={title} className="flex items-center gap-3 p-2 rounded-lg bg-surface/50">
              <span className="text-2xl shrink-0">{icon}</span>
              <div className="min-w-0">
                <div className="text-sm font-medium text-ink">{title}</div>
                <div className="text-xs text-muted truncate">{desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 底部 */}
        <div className="mt-auto py-6 text-center text-xs text-muted/50">
          © 2026 快船 · kuaichuan.bot.cd
        </div>
      </div>

      {/* 强制登录弹窗（不可关闭） */}
      <AuthModal required onClose={() => {}} />
    </>
  );
}
